/* jshint esversion: 6 */
import React from 'react';
import ChooserHeader from 'app/components/SubaccountSelector/ChooserHeader.jsx';
import ChooserMain from 'app/components/SubaccountSelector/ChooserMain.jsx';

class SlackOutput extends React.Component {
    render() {
        return (
            <div>
                <ChooserHeader
                    {...this.props}
                    error={this.props.error}
                    headerCopy="Select a Channel"/>
                <ChooserMain
                    {...this.props}
                    allConnectedMessage={(
                        <p className="chooser-notice">You've already connected all your Pinterest Boards to dlvr.it</p>
                    )}
                    typeLabel="You've already connected all your Slack Channels to dlvr.it"/>
            </div>
        );
    }
}

SlackOutput.displayName = "SlackOutput";

export default SlackOutput;
